module.exports = __webpack_public_path__ + "static/media/video-placeholder.4bc3dd23.jpg";